<template>
  <v-container id="appointment-services-table" fluid>
    <v-card outlined>
      <v-data-table
        :headers="headers"
        :items="services"
        :options.sync="options"
        :footer-props="footerProps"
        :loading="loadingData"
        :loading-text="$t('appointment.loadingServicesText')"
        :no-data-text="$t('appointment.noServices')"
        @click:row="handleClick"
        style="cursor: pointer"
        mobile-breakpoint="481"
        item-key="id"
        :header-props="headerProps"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" class="mr-1" outlined :to="'/appointment-services/add'">
              <v-icon>mdi-plus</v-icon>
              {{ $t('appointment.addService') }}
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.service_name="{ item }">
          <template v-if="typeof item.service_name === 'object'">
            {{ item.service_name[$root.$i18n.locale] || item.service_name[Object.keys(item.service_name)[0]] }}
          </template>
          <template v-else>
            {{ item.service_name }}
          </template>
        </template>
        <template v-slot:item.duration="{ item }">
          {{ formatDate(item.duration) }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            :class="[$vuetify.breakpoint.width >= 481 ? '' : 'pr-0']"
            text
            color="primary"
            @click="handleClick(item)"
          >
            {{ $t('appointment.edit') }}
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import { EventBus } from '../../event-bus'
  import moment from 'moment'

  export default {
    name: 'InStoreAppointmentServicesTable',
    data() {
      return {
        services: [],
        loadingData: false,
        options: {
          itemsPerPage: 15,
        },
      }
    },
    mounted() {
      this.list()
    },
    activated() {
      let previousPath = this.$store.state.previousPath.split('/')[1]
      // we reset current page number and appointment services per page if the previous page wasn't the details
      // of an appointment service
      if (previousPath !== 'appointment-services') {
        this.options.itemsPerPage = 15
        this.options.page = 1
        this.options.sortBy = []
        this.options.sortDesc = []
      }
      this.services = []
      this.list()
    },
    methods: {
      list() {
        this.loadingData = true
        let myInit = this.buildMyInit()
        this.$Amplify.API.get('appointments', '/int/appointments/services', myInit)
          .then((res) => {
            this.services = res
            if (
              Array.isArray(this.services) &&
              this.services.length < (this.options.page - 1) * this.options.itemsPerPage + 1
            ) {
              let pageNumber = Math.floor(this.services.length / this.options.itemsPerPage)
              this.options.page = pageNumber === 0 ? 1 : pageNumber
            }
            this.loadingData = false
          })
          .catch(() => {
            this.loadingData = false
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: 'error during appointments loading',
              color: 'error',
            })
          })
      },
      buildMyInit() {
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
        }
        return myInit
      },
      async reloadList() {
        await this.$auth.isAuthenticated()
        this.options.page = 1
        this.list()
      },
      handleClick(data) {
        this.$router.push({
          name: 'appointmentServiceDetails',
          params: {
            id: data._id,
            duration_props: Math.floor(data.duration / 60),
            enabled_props: data.enabled,
            service_name_props: data.service_name,
            videoconference_props: data.videoconference,
            seller_service_props: data.seller_service || false,
          },
        })
      },
      formatDate(seconds) {
        if (seconds >= 3600) {
          return moment.utc(seconds * 1000).format('HH[h]mm')
        } else {
          return moment.utc(seconds * 1000).format('m[ min]')
        }
      },
    },
    watch: {
      options: {
        handler() {
          this.list()
        },
      },
    },
    computed: {
      headers() {
        return [
          {
            text: this.$t('appointment.name'),
            value: 'service_name',
          },
          {
            text: this.$t('appointment.duration'),
            value: 'duration',
          },
          {
            text: '',
            value: 'action',
            sortable: false,
          },
        ]
      },
      footerProps() {
        return {
          'items-per-page-options': [15, 30, 50],
          'items-per-page-text': this.$t('appointment.resultsPerPage'),
        }
      },
      headerProps() {
        return {
          sortByText: this.$t('order.sortByText'),
        }
      },
    },
  }
</script>
